import { css, SerializedStyles } from '@emotion/react';
import { theme } from 'global';

export const labelContainer = css`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const label = (
  variant: 'primary' | 'success' | 'info'
): SerializedStyles => {
  const style =
    variant !== 'info'
      ? css``
      : css`
          color: ${theme.colors.info};
          background-color: ${theme.colors.infoLight};
        `;
  return style;
};

export const tableHeader = css`
  color: ${theme.colors.primary.dark};
`;

export const tableCell = css`
  color: ${theme.colors.neutral[600]};
`;

export const tooltipWidth = css`
  width: 'fit-content';
`;

export const labelText = css`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.5px;
`;
